import {Alert} from '@wandb/weave/components/Alert';
import {Timestamp} from '@wandb/weave/components/Timestamp';
import React from 'react';
import {Link} from 'react-router-dom';

import YAML from '../../../../services/yaml';
import {Analytics} from '../../../services/analytics';
import {queue as queueUrl} from '../../../util/urls';
import {CodeEditor} from '../CodeEditor';
import {useQueueNames} from '../Queues/hooks';
import {Agent} from '../utilTypes';
import {SemanticLoader as Loader} from './../../utility/InstrumentedLoader';
import * as S from './TabOverview.styles';

type TabOverviewProps = {
  entityName: string;
  agent: Agent;
};

export const TabOverview = ({entityName, agent}: TabOverviewProps) => {
  const configYaml: string = YAML.stringify(JSON.parse(agent.config)).slice(
    0,
    -1
  );
  const {queues, error, loading} = useQueueNames(entityName);

  let runQueues;

  if (error) {
    runQueues = <Alert severity="error">Error loading queue information</Alert>;
  } else if (loading) {
    runQueues = <Loader active inline size="tiny" name="tab-overview-loader" />;
  } else {
    runQueues = (
      <ul>
        {queues
          .filter(q => agent.runQueues.includes(q.id))
          .map(q => {
            const queueLink = queueUrl(entityName, q.id);
            return (
              <li key={q.name}>
                <Link
                  to={{
                    pathname: queueLink,
                  }}
                  onClick={() => {
                    Analytics.track('view queue detail', {
                      queueLink,
                      location: 'agent overview',
                    });
                  }}>
                  {q.name}
                </Link>
              </li>
            );
          })}
      </ul>
    );
  }
  return (
    <>
      <S.SectionTitle>Agent metadata</S.SectionTitle>
      <S.MetadataTable>
        <S.Tr>
          <S.Property>Creation date</S.Property>
          <S.ContentPanel>
            <Timestamp value={agent.createdAt} />
          </S.ContentPanel>
        </S.Tr>
        {agent.heartbeatAt && (
          <S.Tr>
            <S.Property>Last heartbeat</S.Property>
            <S.ContentPanel>
              <Timestamp value={agent.heartbeatAt} />
            </S.ContentPanel>
          </S.Tr>
        )}
        <S.Tr>
          <S.Property>Host</S.Property>
          <S.ContentPanel>{agent.hostname}</S.ContentPanel>
        </S.Tr>
        <S.Tr>
          <S.Property>Version</S.Property>
          <S.ContentPanel>{agent.version ?? 'Unknown'}</S.ContentPanel>
        </S.Tr>
        <S.Tr>
          <S.Property>Queues</S.Property>
          <S.ContentPanel>{runQueues}</S.ContentPanel>
        </S.Tr>
        <S.Tr>
          <S.Property>Config</S.Property>
          <S.ContentPanel>
            {configYaml !== 'null' ? (
              <CodeEditor value={configYaml} language="yaml" readOnly={true} />
            ) : (
              'None'
            )}
          </S.ContentPanel>
        </S.Tr>
      </S.MetadataTable>
    </>
  );
};
